import React, { useState } from "react";
import logo from "../images/logo.png";
import logoWhite from "../images/logo_white.png";

const Header = ({ theme, changeTheme }) => {
    const [isMobileMenuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
        setMenuOpen(!isMobileMenuOpen);
    };

    return (
        <header>
            <a href="#" className="anchor-logo">
                <div className="logoDiv">
                    <div className="logo">
                        <img src={theme === "dark-theme" ? logoWhite : logo} style={{ width: "100%" }} alt="Logo" />
                    </div>
                    <span className="logoText">
                        <span>Coding With Karthik</span>
                        <span className="logoSubText">
                            <i className="fa fa-circle"></i>Innovation<i className="fa fa-circle"></i>Implementation<i className="fa fa-circle"></i>Solution
                        </span>
                    </span>
                </div>
            </a>
            <div className={`navOptions ${isMobileMenuOpen ? "open" : ""}`}>
                <span>
                    <a className="anchor" href="https://www.linkedin.com/in/karthik-reddy-s-92a727b5/" target="_blank" rel="noopener noreferrer">LinkedIn
                        <i className="fa fa-linkedin" aria-hidden="true"></i>
                    </a>
                </span>
                <span>
                    <a className="anchor" href="https://www.youtube.com/channel/UCTbKSzEamYTYYY_c2yH1fEA" target="_blank" rel="noopener noreferrer">Youtube
                        <i className="fa fa-youtube-play" aria-hidden="true"></i>
                    </a>
                </span>
                <span>
                    <a className="anchor" href="https://github.com/karthik-skr?tab=repositories" target="_blank" rel="noopener noreferrer">Github
                        <i className="fa fa-github" aria-hidden="true"></i>
                    </a>
                </span>
                <span>
                    <a className="anchor" href="https://medium.com/@karthik.skreddy24" target="_blank" rel="noopener noreferrer">Medium
                        <i className="fa fa-medium" aria-hidden="true"></i>
                    </a>
                </span>
                <span onClick={toggleMenu}>
                    <a className="anchor" href="#contactMe">Contact
                        <i className="fa fa-paper-plane" aria-hidden="true"></i>
                    </a>
                </span>
                <span>
                    <a className="anchor" href="https://docs.google.com/document/d/1XgPweaJrfIGxCuLhmkDLyNqvTP1zhiU9/edit?usp=sharing&ouid=116628453849423542964&rtpof=true&sd=true" target="_blank" rel="noopener noreferrer" download>Resume
                        <i className="fa fa-download" aria-hidden="true"></i>
                    </a>
                </span>
                <span className="theme-switch desktop">
                    Light
                    <label className="switch">
                        <input type="checkbox" onChange={changeTheme} checked={theme === "dark-theme"}></input>
                        <span className="slider round"></span>
                    </label>
                    Dark
                </span>
            </div>
            <div className="menuToggle">
                <span className="theme-switch">
                    <label className="switch">
                        <input type="checkbox" onChange={changeTheme} checked={theme === "dark-theme"}></input>
                        <span className="slider round"></span>
                    </label>
                </span>
                <div onClick={toggleMenu} className="bars">
                    <i className={`fa ${isMobileMenuOpen ? "fa-close" : "fa-bars"}`}></i>
                </div>
            </div>
        </header>
    );
};

export default Header;
